import { createContext, useContext, useState, type ReactNode } from 'react';

interface ApplicationContextType {
  industryIdToApply: string | null;
  setIndustryIdToApply: (id: string | null) => void;
}

const ApplicationContext = createContext<ApplicationContextType | undefined>(
  undefined
);

export const ApplicationProvider = ({ children }: { children: ReactNode }) => {
  const [industryIdToApply, setIndustryIdToApply] = useState<string | null>(
    null
  );

  return (
    <ApplicationContext.Provider
      value={{ industryIdToApply, setIndustryIdToApply }}
    >
      {children}
    </ApplicationContext.Provider>
  );
};

export const useApplicationContext = () => {
  const context = useContext(ApplicationContext);
  if (!context) {
    throw new Error(
      'useApplicationContext must be used within ApplicationProvider'
    );
  }
  return context;
};
